import { Text } from '../../FormControls/Text';
import { Fragment } from 'react';
import { Stack } from '../../FormControls/Stack';
import { ScreenControl } from '../ScreenControl';
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from 'react-redux';

export const Success = ({ dimensions }) => {

    const [cookies] = useCookies(["token", "u"]);
    const state = useSelector(({ bussines }) => bussines.storeId);

    let store = cookies["Store"] || state

    const redirect = async () => {window.location.replace(`${window.location.origin}/Admin/MiBitpos?StoreID=${store}`);}

    return (
        <Fragment>
            <Stack
                flex={{
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center"
                }}
                sx={{ ...dimensions }}
            >

                {/* SCREEN LEGENDS */}
                <Text classes={["subtitle"]}> Felicitaciones!</Text>
                <Text classes={["title"]}> Ya puedes utilizar tu Bitpos </Text>
                <Text classes={["subtitle"]}> Haz click en continuar para visualizar tu bitpos</Text>

            </Stack>
            <ScreenControl
                disabled={false}
                beforeSubmit={() => redirect()}
            ></ScreenControl>
        </Fragment>
    )
}